<app-system-message></app-system-message>
<!-- Container for the form with dynamic styling -->
<div [ngClass]="theme.getThemeClass()" class="container-fluido">
    <section [ngClass]="theme.getThemeClass()" class="card bg-light">
        <article class="card-body mx-auto article">
            <h4 class="card-title mt-0 text-center">{{ 'operatorUpdateViewUpdateOperator' | translate }}</h4>
            <form>
                <!-- Input for operator name -->
                <label class="label-spacer" for="distributor_name">{{ 'operatorCreateViewOperatorName' | translate }} <span class="requiredStar">*</span></label>
                <div class="input-group mb-3 firstInput">
                    <span class="input-group-text" id="basic-addon1"><i class="fa fa-user"></i></span>
                    <input [(ngModel)]="this.operator.operator_data.operator_name" type="text"
                    class="form-control" name="operator_name"
                    placeholder="{{ 'operatorCreateViewOperatorName' | translate }}" aria-label="operator_name"
                    aria-describedby="basic-addon1"
                    (blur)="this.validationService.validateNameInput(this.operator.operator_data.operator_name, 'userclientLegalName')"
                    [class.error-border]="this.validationService.validationErrorArray[0] == 'usernameInvalid'">
                </div>
                <!-- Input for operator legal name -->
                <label class="label-spacer" for="distributor_name">{{ 'legalName' | translate }} <span class="requiredStar">*</span></label>
                <div class="input-group mb-3 firstInput">
                    <span class="input-group-text" id="basic-addon1"><i class="fa fa-user"></i></span>
                    <input [(ngModel)]="this.operator.operator_data.legal_name" type="text"
                    class="form-control" name="legal_name"
                    placeholder="{{ 'clientcreateFormInputLegalName' | translate }}" aria-label="legal_name"
                    aria-describedby="basic-addon1"
                    (blur)="this.validationService.validateNameInput(this.operator.operator_data.legal_name, 'userclientLegalName')"
                    [class.error-border]="this.validationService.validationErrorArray[0] == 'clientLegalNameInvalid'">
                </div>
                <!-- Input for operator phone number -->
                <label class="label-spacer" for="distributor_name">{{ 'userlistClientsViewTableHeaderPhoneNumber' | translate }} <span class="requiredStar">*</span></label>
                <div class="input-group mb-3 firstInput">
                    <span class="input-group-text" id="basic-addon1"><i class="fa fa-phone"></i></span>
                    <input [(ngModel)]="this.operator.operator_data.phone_number" type="text"
                    class="form-control telefone-input" name="phone_number"
                    placeholder="(000)-000-0000" aria-label="phone_number"
                    aria-describedby="basic-addon1"
                    (blur)="this.validationService.validatePhoneNumber(this.operator.operator_data.phone_number)"
                    [class.error-border]="this.validationService.validationErrorArray[0] == 'clientPhoneInvalid'">
                </div>
                <!-- Input field for address with Autocomplete -->
                <label class="label-spacer" for="distributor_name">{{ 'address' | translate }} <span class="requiredStar">*</span></label>
                <div class="input-group mb-3">
                    <span class="input-group-text" id="basic-addon1"><i class="fas fa-map-marker"></i></span>
                    <input id="autocomplete" [(ngModel)]="this.operator.operator_data.address" (keydown)="onInputAddressKeydown($event);"
                    type="text" class="form-control" name="address"
                    placeholder="{{ 'clientcreateFormInputFindAddress' | translate }}"aria-label="Enter a place" aria-describedby="basic-addon1"
                    (blur)="this.validationService.validateAddress(this.operator.operator_data.address)"
                    [class.error-border]="this.validationService.validationErrorArray[0] == 'clientAddressInvalid'">
                </div>
                <!-- Input for operator email -->
                <label class="label-spacer" for="distributor_name">{{ 'email' | translate }} <span class="requiredStar">*</span></label>
                <div class="input-group mb-3 firstInput">
                    <span class="input-group-text" id="basic-addon1"><i class="fa fa-envelope"></i></span>
                    <input [(ngModel)]="this.operator.operator_data.email" type="text"
                    class="form-control" name="email"
                    placeholder="{{ 'loginForgotPasswordPlaceHolderEmailAddress' | translate }}" aria-label="email"
                    aria-describedby="basic-addon1"
                    (blur)="this.validationService.validateClientEmail(this.operator.operator_data.email)"
                    [class.error-border]="this.validationService.validationErrorArray[0] == 'clientEmailInvalid'">
                </div>
                <!-- Input for billable flag -->
                <label class="label-spacer" for="billable">{{ 'billable' | translate }}</label>
                <div class="input-group mb-3 firstInput">
                    <span class="input-group-text" id="basic-addon1"><i class="fa fa-money-bill"></i></span>
                    <select
                      id="billable"
                      name="billable"
                      class="form-control"
                      [(ngModel)]="this.billableValue"
                    >
                      <option [ngValue]="0">{{ 'no' | translate }}</option>
                      <option [ngValue]="1">{{ 'yes' | translate }}</option>
                    </select>
                </div>
                <!-- section for the checkbox toggle of the status active/inactive -->
                <label class="toggle">{{ "iotTabHeaderStatus" | translate }} <span class="requiredStar">*</span></label>
                <div class="card-title mt-0 status">
                    <label class="switch">
                        <input type="checkbox" id="checkboxStatus" [name]="'active-operator-' + operator.operator_data.operator_id" [ngModel]="this.active" (change)="this.alert.showAlertDelete= true; this.alert.deactiveOperator(operator.operator_data.operator_id, operator.operator_data.legal_name, operator.operator_data.active)" [disabled]="this.alert.showAlertDelete">
                        <span [ngClass]="{'active-checkbox': this.active === 1, 'inactive-checkbox': this.active === 0}" class="slider round"></span>
                    </label>
                </div>
                <!-- Submit button -->
                <nav class="form-group buttonDiv">
                    <button (click)="returnToEntities()" [ngClass]="theme.getThemeClass()" type="submit" class="btn btn-block btnCancel fixed-size">{{ 'clientcreateFormBtnCancel' | translate }}</button>
                    <button [ngClass]="theme.getThemeClass()" (click)="onSubmit()" type="submit" class="btn btn-block btnCreate fixed-size">{{ 'update' | translate }}</button>
                </nav>
                <nav class="form-group buttonDiv">
                    <button [ngClass]="theme.getThemeClass()" class="button btn btn-primaryy btnCancel fixed-size red" (click)="deleteOperator()">{{ 'delete' | translate }}</button>
                </nav>
            </form>
        </article>
        @if (this.alert.showAlertDelete) {
        <app-alert-modal class="alertDelete" [ngClass]="theme.getThemeClass()"></app-alert-modal>
        }
    </section>
</div>
